import { ELanguage } from '@microfrontends/react-components'
import CompanyListPage from '../../components/CompanyListPage'
import { getServerSideProps } from '../../ssr/companyList'
import { AppStoreProvider } from '../../store'
import { TPageProps } from '../company-list'

const CompanyDetailPage = (props: TPageProps) => {
    const { jsToken, wsToken, user, appMode, companyList, keyword = '', industries = [], seoKeywords } = props

    return (
        <AppStoreProvider langCode={ELanguage.VI}>
            <CompanyListPage
                seoKeywords={seoKeywords}
                jsToken={jsToken}
                wsToken={wsToken}
                companyList={companyList}
                keywordFromUrl={keyword}
                industriesFromUrl={industries}
                langCode={ELanguage.VI}
                user={user}
                appMode={appMode}
            />
        </AppStoreProvider>
    )
}

export default CompanyDetailPage

export { getServerSideProps }
